export const quizSections = [
    {
      title: "Diet",
      questions: [
        {
          id: "diet_vegetables",
          text: "How many days this week did you eat at least one bowl of vegetables (approximately)?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 1.5
        },
        {
          id: "diet_fruit",
          text: "How many days this week did you eat at least one bowl of fruit (approximately)?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 1.5
        },
        {
          id: "diet_berries",
          text: "How many days this week did you consume at least 1/2 cup of berries?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 1.1
        },
        {
          id: "diet_water",
          text: "How many days this week did you consume at least 6 cups of plain water?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 1.0
        },
        {
          id: "diet_omega3",
          text: "How many days this week did you consume foods rich in Omega-3 (fatty fish, shellfish, walnuts, flaxseed)?",
          options: [[0, 0], [1, 2], [2, 4], [3, 6], [4, 8], [5, 10], [6, 10], [7, 10]],
          weight: 1.0
        },
        {
          id: "diet_olive_oil",
          text: "How many days this week did you consume at least 1 tablespoon of olive oil?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 0.8
        },
        {
          id: "diet_tea_coffee",
          text: "How many days this week did you drink [tooltip:not for caffeine but for flavonoids]tea or coffee[/tooltip]?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 0.3
        },
        {
          id: "diet_protein",
          text: "How many days this week did you consume adequate protein ([tooltip: 53 grams or about 2 chicken breasts for a 150lb person]0.35g/lb body weight[/tooltip])?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 0
        },
        {
          id: "diet_processed",
          text: "How many days this week did you consume [tooltip: Ultra-processed foods include packaged snacks (chips, cookies), sugary cereals, instant noodles, frozen dinners, soft drinks, candy, fast food, and most items with long shelf lives containing additives, preservatives, or artificial ingredients. If it has a longer shelf life than if you made it at home, it's likely ultra-processed]highly processed foods[/tooltip]?",
          options: [[0, 10], [1, 8.6], [2, 7.1], [3, 5.7], [4, 4.3], [5, 2.9], [6, 1.4], [7, 0]],
          weight: 1.0
        },
        {
          id: "diet_red_meat",
          text: "How many days this week did you eat red meat?",
          options: [[0, 0], [1, 10], [2, 8], [3, 6], [4, 4], [5, 2], [6, 1], [7, 0]],
          weight: 0.8
        },
        {
          id: "diet_fried",
          text: "How many days this week did you eat fried foods or foods high in saturated fat?",
          options: [[0, 10], [1, 8.6], [2, 7.1], [3, 5.7], [4, 4.3], [5, 2.9], [6, 1.4], [7, 0]],
          weight: 1.0
        },
        {
          id: "diet_sugar",
          text: "How many days this week did you consume foods with [tooltip: more than 2 grams (1/2 teaspoon) per serving of added sugar]significant added sugars?[/tooltip]",
          options: [[0, 10], [1, 8.6], [2, 7.1], [3, 5.7], [4, 4.3], [5, 2.9], [6, 1.4], [7, 0]],
          weight: 1.0
        },
        {
          id: "diet_alcohol",
          text: "How many alcoholic drinks did you consume this week?",
          options: [
            [0, 7], 
            ["1-3", 8], 
            ["4-7", 10], 
            ["8-14", 6], 
            ["15+", 0]
          ],
          weight: 1.0
        }
      ]
    },
    {
      title: "Exercise",
      questions: [
        {
          id: "exercise_steps",
          text: "How many days this week did you walk or run at least 6,000 steps?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 1.5
        },
        {
          id: "exercise_cardio",
          text: "How many days this week did you do cardio that got your heart rate above 130 bpm?",
          options: [[0, 0], [1, 3.3], [2, 6.7], [3, 10], [4, 10], [5, 10], [6, 10], [7, 10]],
          weight: 1.0
        },
        {
          id: "exercise_resistance",
          text: "How many days this week did you do resistance training (weights, bodyweight exercises)?",
          options: [[0, 0], [1, 6], [2, 6], [3, 10], [4, 10], [5, 10], [6, 10], [7, 10]],
          weight: 1.0
        },
        {
          id: "exercise_flexibility",
          text: "How many days this week did you do yoga, stretching, or other flexibility exercises?",
          options: [[0, 0], [1, 3.3], [2, 6.7], [3, 10], [4, 10], [5, 10], [6, 10], [7, 10]],
          weight: 0.8
        },
        {
          id: "exercise_total",
          text: "On how many days did you exercise for at least 30 minutes total?",
          options: [[0, 0], [1, 2], [2, 4], [3, 6], [4, 8], [5, 10], [6, 10], [7, 10]],
          weight: 1.2
        }
      ]
    },
    {
      title: "Sleep",
      questions: [
        {
          id: "sleep_hours",
          text: "How many nights this week did you sleep between 7-9 hours?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 2.0
        },
        {
          id: "sleep_quality",
          text: "How many nights this week did you feel that you had restful, high-quality sleep?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 1.5
        }
      ]
    },
    {
      title: "Community",
      questions: [
        {
          id: "community_time",
          text: "How many days this week did you spend at least 1 hour of quality time with friends, family, or your partner?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 1.5
        },
        {
          id: "community_group",
          text: "How many times this week did you participate in a group activity (club, class, religious service, volunteer work)?",
          options: [[0, 0], [1, 7], [2, 9], [3, 10], ["4+", 10]],
          weight: 1.0
        },
        {
            id: "community_support",
            text: "Imagine you had a life problem - this week, would you have someone available to support you?",
            options: [["Probably not", 0], ["Maybe", 6], ["Probably or Definitely", 10]],
            weight: 0.8
        }
      ]
    },
    {
      title: "Mental Activity",
      questions: [
        {
          id: "mental_challenging",
          text: "How many days this week did you spend at least 1 hour on mentally challenging activities?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 1.5
        },
        {
          id: "mental_reading",
          text: "How many days this week did you read (or listen to) books, articles, or other substantive material?",
          options: [[0, 0], [1, 2], [2, 4], [3, 6], [4, 8], [5, 10], [6, 10], [7, 10]],
          weight: 1.0
        },
        {
          id: "mental_creative",
          text: "How many days this week did you engage in creative activities (art, music, writing, etc.)?",
          options: [[0, 0], [1, 3.3], [2, 6.7], [3, 10], [4, 10], [5, 10], [6, 10], [7, 10]],
          weight: 0.8
        },
        {
            id: "mental_sharpness",
            text: "How mentally sharp did you feel this week, on average, 5 being the sharpest?",
            options: [[0, 0], [1, 3.3], [2, 6.7], [3, 10], [4, 10], [5, 10]],
            weight: 0
        }
      ]
    },
    {
      title: "Stress Management",
      questions: [
        {
          id: "stress_level",
          text: "How many days this week did you feel excessive stress?",
          options: [[0, 10], [1, 8.6], [2, 7.1], [3, 5.7], [4, 4.3], [5, 2.9], [6, 1.4], [7, 0]],
          weight: 0.7
        },
        {
          id: "stress_meditation",
          text: "How many days this week did you practice meditation, deep breathing, or mindfulness?",
          options: [[0, 0], [1, 2], [2, 4], [3, 6], [4, 8], [5, 10], [6, 10], [7, 10]],
          weight: 1.0
        },
        {
          id: "stress_breaks",
          text: "How many [tooltip: If you don't work or attend school choose all workdays, if you attend school count schooldays as workdays]workdays[/tooltip] this week did you take regular short breaks to relax?",
          options: [[0, 0], [1, 2], [2, 4], [3, 6], [4, 8], ["All workdays", 10]],
          weight: 0.8
        },
        {
          id: "stress_relaxation",
          text: "How many days this week did you engage in activities specifically for relaxation?",
          options: [[0, 0], [1, 2.5], [2, 5], [3, 7.5], [4, 8], [5, 9], [6, 10], [7, 10]],
          weight: 1.0
        }
      ]
    },
    {
      title: "General Health",
      questions: [
        {
            id: "health_checkup",
            text: "When was your last [tooltip: A comprehensive checkup includes physical exam, blood tests, vital signs, and screening for major health conditions]comprehensive health checkup[/tooltip]?",
            options: [
              ["Within the last 6 months", 10], 
              ["Within the last year", 8], 
              ["1-2 years ago", 5], 
              ["More than 2 years ago", 2], 
              ["Never/Can't remember", 0]
            ],
            weight: 1.5
        },
        {
          id: "health_cholesterol",
          text: "In your last checkup, were your cholesterol levels within normal ranges?",
          options: [
            ["Yes", 10], 
            ["No", 3], 
            ["I haven't had these levels checked in the last year", 0]
          ],
          weight: 1.0
        },
        {
          id: "health_bloodpressure",
          text: "In your last checkup, was your blood pressure level within the healthy range?",
          options: [
            ["Yes", 10], 
            ["No", 3], 
            ["I haven't had this level checked in the last year", 0]
          ],
          weight: 1.2
        },
        {
          id: "health_bloodsugar",
          text: "In your last checkup, was your blood sugar level within the healthy range?",
          options: [
            ["Yes", 10], 
            ["No", 3], 
            ["I haven't had this level checked in the last year", 0]
          ],
          weight: 1.0
        },
        {
          id: "health_medication",
          text: "How consistently did you take prescribed medications this week?",
          options: [
            ["Took all medications as prescribed", 10], 
            ["Missed 1-2 doses", 7], 
            ["Missed several doses", 3], 
            ["Not currently on any prescribed medications", 10]
          ],
          weight: 1.0
        },
        {
          id: "health_vaccinations",
          text: "Are your vaccinations up to date, including recommended boosters?",
          options: [
            ["Yes, fully up to date", 10], 
            ["Mostly up to date", 7], 
            ["No, many are outdated", 3], 
            ["I don't know", 0]
          ],
          weight: 1.0
        },
        {
          id: "health_bmi",
          text: "In what range is your <a href = 'https://www.nhlbi.nih.gov/health/educational/lose_wt/BMI/bmicalc.htm'>Body Mass Index (BMI)</a>?",
          options: [
            ["My BMI is below 19", 4],  
            ["My BMI is between 19-26", 10], 
            ["My BMI is between 26-30", 8], 
            ["My BMI is above 30", 3], 
            ["I don't know my BMI", 0]
          ],
          weight: 1.3
        }
      ]
    },
    {
      title: "Mental Health",
      questions: [
        {
          id: "mental_health_mood",
          text: "How many days this week did you experience depression, anxiety, or other significant mood problems?",
          options: [[0, 10], [1, 8.6], [2, 7.1], [3, 5.7], [4, 4.3], [5, 2.9], [6, 1.4], [7, 0]],
          weight: 1.5
        },
        {
          id: "mental_health_coping",
          text: "How many days this week did you use [tooltip: Drugs, drinking, self-harm, and aggressive behavior are examples of coping mechanisms that could be considered unhealthy]unhealthy coping mechanisms[/tooltip] for emotional challenges?",
          options: [[0, 10], [1, 5], [2, 2], [3, 1], [4, 0], [5, 0], [6, 0], [7, 0]],
          weight: 1.0
        },
        {
          id: "mental_health_balance",
          text: "How many days this week did you fail to maintain a healthy work-life balance?",
          options: [[0, 10], [1, 8.6], [2, 7.1], [3, 5.7], [4, 4.3], [5, 2.9], [6, 1.4], [7, 0]],
          weight: 1.0
        },
        {
          id: "mental_health_purpose",
          text: "How many days this week did you engage in activities that give you a sense of purpose or meaning?",
          options: [[0, 0], [1, 2], [2, 4], [3, 6], [4, 8], [5, 10], [6, 10], [7, 10]],
          weight: 1.0
        },
        {
            id: "mental_health_overallmood",
            text: "On average how positive was your mood this week? A score of 7 is an average happy day.",
            options: [["0 - severely depressed ", 0], [1, 1], [2, 2], [3, 3], [4, 4], [5, 5], [6, 6], [7, 7], [8, 8], [9, 9], ["10 - Extremely happy, maybe a little too much", 10]],
            weight: 0
        },
        {
          id: "mental_health_support",
          text: "If you're struggling with your mental health, and are seeing a mental health professional, how consistent have you been with treatment?",
          options: [
            ["Very consistent", 10], 
            ["Somewhat consistent", 7], 
            ["Not very consistent", 3], 
            ["Not working with a mental health professional but struggle with mental health", 0], 
            ["Not currently struggling with my mental health", 10]
          ],
          weight: 1.0
        },
        {
            id: "mental_health_group",
            text: "How consistently are you working on self improvement with guidance from a therapist, coach, group or similar?",
            options: [
              ["Very consistent", 10], 
              ["Somewhat consistent", 7], 
              ["Not very consistent", 3], 
              ["Not seeking outside guidance", 0]
            ],
            weight: 0.8
        }
      ]
    },
    {
      title: "Environmental Factors",
      questions: [
        {
          id: "environment_air",
          text: "How many days this week were you exposed to poor air quality (pollution, smoke, etc.) for more than an hour?",
          options: [[0, 10], [1, 8.6], [2, 7.1], [3, 5.7], [4, 4.3], [5, 2.9], [6, 1.4], [7, 0]],
          weight: 1.5
        },
        {
          id: "environment_produce",
          text: "How many days this week did you thoroughly wash all produce before consuming?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 1.0
        },
        {
          id: "environment_plastic",
          text: "How many days this week did you consume food heated in plastic containers, cooked on a teflon pan, cut on a plastic cutting board, or stored multiple days in plastic tupperware?",
          options: [[0, 10], [1, 8.6], [2, 7.1], [3, 5.7], [4, 4.3], [5, 2.9], [6, 1.4], [7, 0]],
          weight: 1.0
        },
        {
          id: "environment_water",
          text: "How many days this week did you drink only filtered water?",
          options: [[0, 0], [1, 1.4], [2, 2.9], [3, 4.3], [4, 5.7], [5, 7.1], [6, 8.6], [7, 10]],
          weight: 0.8
        }
      ]
    }
  ];